export default {
//API_URL: 'http://192.168.100.137:8085', 
//MISREPORT_API_URL: 'http://192.168.100.137:8081', 

//new stage url
//API_URL: 'http://3.7.22.114:8081', 
//MISREPORT_API_URL: 'http://3.7.22.114:8081', 
//new stage url


 //API_URL: 'http://13.234.176.138',
//API_URL: 'http://192.168.100.119' ,

API_URL: 'https://api.firstcrylogistics.com',
MISREPORT_API_URL:'https://api.firstcrylogistics.com/migration',
MIGRATION_API_URL:'https://api.firstcrylogistics.com/migration'


// API_URL: 'http://10.0.14.112',
// MISREPORT_API_URL:'http://10.0.14.112:8082/migration',
// MIGRATION_API_URL:'http://10.0.14.112:8082/migration'

// API_URL: 'http://10.0.14.97:8082/',
// MISREPORT_API_URL:'http://10.0.14.97:8082/migration',
// MIGRATION_API_URL:'http://10.0.14.97:8082/migration'
  //BASE_URL: 'http://192.168.100.136:8888',
  //BASE_URL: 'http://www.firstcrylogistics.com'
  //API_URL: 'http://localhost:8045'
}
